import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isEmpty, omit, pick } from 'lodash';

/**
 * ListActionPaths
 *
 * Retrieves a list of action paths from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ListActionPaths = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = omit(payload?.[2], ['page', 'size', 'sort']);
    const thePagination = pick(payload?.[2], ['page', 'size', 'sort']);

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': '/action-paths',
      },
      method: 'GET',
      params: { ...{ apiKey: theApiKey, queryKey: theQueryKey }, ...thePagination },
    };

    if (!isEmpty(thePayload)) {
      requestArgs.headers['x-api-endpoint'] += '/search';
      requestArgs.method = 'POST';
      requestArgs.data = thePayload;
    }

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/ActionPath/api/requests/queries/ListActionPaths.js -> ListActionPaths()', false, error);

    throw error;
  }
};
